import { memo } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material";

import { StatusChip } from "components";
import { STATUS_CHIP } from "constants";

import { getUploadNameTone } from "../makeData";

const TONE_TO_CHIP_TYPE = {
  success: STATUS_CHIP?.success,
  info: STATUS_CHIP?.info,
  warning: STATUS_CHIP?.warning,
  neutral: STATUS_CHIP?.attention,
};

const UploadNameTag = ({ uploadName }) => {
  const theme = useTheme();
  const tone = getUploadNameTone(uploadName);

  const style =
    tone === "neutral"
      ? {
          color: theme.palette.text.secondary,
          background: theme.palette.grey[200],
        }
      : undefined;

  return (
    <StatusChip
      type={TONE_TO_CHIP_TYPE[tone]}
      label={uploadName}
      style={style}
    />
  );
};

UploadNameTag.propTypes = {
  uploadName: PropTypes.string.isRequired,
};

export default memo(UploadNameTag);
